import {
  SlidersHorizontal,
  ThumbsUp,
  ThumbsDown,
  FolderOpen,
  Gavel,
  Users,
  Megaphone,
  Award,
  DollarSign,
  GraduationCap,
  FileSearch,
  Building2,
  Globe2,
  Radar,
  Newspaper,
  Search as SearchIcon,
} from "lucide-react";
import { icons as lucideIcons } from "lucide-react";

/* ─── helpers ─── */
export const cn = (...c) => c.filter(Boolean).join(" ");

/* ─── Constants ─── */
export const SORT_OPTIONS = [
  { key: "newest", label: "Newest First" },
  { key: "oldest", label: "Oldest First" },
];

export const FILTER_OPTIONS = [
  { key: "all", label: "All", icon: SlidersHorizontal },
  { key: "liked", label: "Liked", icon: ThumbsUp },
  { key: "disliked", label: "Disliked", icon: ThumbsDown },
  { key: "cataloged", label: "Saved", icon: FolderOpen },
];

/* ─── Content type badge config ─── */
export const TYPE_BADGES = {
  court_cases: { icon: Gavel, color: "#f59e0b", label: "Court Case" },
  neighbors: { icon: Users, color: "#8b5cf6", label: "Neighbors" },
  press_release: { icon: Megaphone, color: "#10b981", label: "Press Release" },
  gov_award: { icon: Award, color: "#f97316", label: "Gov Award" },
  financial_crawl: { icon: DollarSign, color: "#06b6d4", label: "Financial" },
  edu_crawl: { icon: GraduationCap, color: "#ec4899", label: "Education" },
  investigative_doc: {
    icon: FileSearch,
    color: "#ef4444",
    label: "Investigative",
  },
  company_subsidiary: {
    icon: Building2,
    color: "#6366f1",
    label: "Subsidiary",
  },
  domain_crawl: { icon: Globe2, color: "#14b8a6", label: "Domain Crawl" },
  hunt: { icon: Radar, color: "#0ea5e9", label: "Hunt" },
  apt_news: { icon: Newspaper, color: "#e11d48", label: "APT News" },
  web_citation: { icon: SearchIcon, color: "#c5548ee3", label: "User Hunted" },
};

/* ─── Icon lookup for feed views ─── */
// Convert PascalCase component name to kebab-case key for storage
export const pascalToKebab = (str) =>
  str.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();

// Build a lookup: kebab-key → component, and a sorted list for the picker
export const LUCIDE_ICON_ENTRIES = Object.entries(lucideIcons)
  .filter(([name]) => {
    if (/^\d/.test(name)) return false;
    if (name.length <= 1) return false;
    return true;
  })
  .map(([name, component]) => ({
    key: pascalToKebab(name),
    name,
    component,
  }))
  .sort((a, b) => a.key.localeCompare(b.key));

export const LUCIDE_ICON_MAP = {};
LUCIDE_ICON_ENTRIES.forEach((e) => {
  LUCIDE_ICON_MAP[e.key] = e.component;
});

export const feedViewIcon = (key) =>
  LUCIDE_ICON_MAP[key] || lucideIcons.SlidersHorizontal;

/* ─── Curated popular icons shown by default (no search) ─── */
export const POPULAR_ICON_KEYS = new Set([
  "globe",
  "earth",
  "radar",
  "shield",
  "shield-alert",
  "shield-check",
  "sliders-horizontal",
  "crosshair",
  "newspaper",
  "file-text",
  "bookmark",
  "rss",
  "search",
  "star",
  "heart",
  "bell",
  "eye",
  "lock",
  "unlock",
  "zap",
  "flame",
  "target",
  "flag",
  "tag",
  "hash",
  "at-sign",
  "activity",
  "trending-up",
  "bar-chart-3",
  "pie-chart",
  "cpu",
  "server",
  "database",
  "hard-drive",
  "wifi",
  "cloud",
  "folder",
  "file",
  "code",
  "terminal",
  "bug",
  "skull",
  "alert-triangle",
  "alert-circle",
  "info",
  "check-circle",
  "user",
  "users",
  "building",
  "building-2",
  "briefcase",
  "calendar",
  "clock",
  "map-pin",
  "compass",
  "navigation",
  "send",
  "mail",
  "link",
  "external-link",
  "download",
  "upload",
  "share-2",
  "layers",
  "grid",
  "list",
  "layout",
  "layout-dashboard",
  "monitor",
  "smartphone",
  "key",
  "fingerprint",
  "scan",
]);
